<template>
  <div class="certMessage">
    <van-divider
      :style="{ color: '#1989fa', borderColor: '#1989fa', 
      margin:0,height:'50px',fontSize:'16px',}"
    >
      基本信息
    </van-divider>
    <van-notice-bar color="red" background="#FEF0F0" left-icon="warning" text="注意：每个身份证号、手机号每天只允许登记2次信息，填写信息后请仔细核对所填写信息，确认信息无误后再点击下一步" />
    
  <van-form ref="ruleForm" :model="ruleForm"  style="opacity: .8;">
      <van-cell-group>
      <van-row >
        <van-cell class="titleStyle" @click="showPickers">1、业务受理点：</van-cell>
      </van-row>
      <van-row class="stationPicker van-field--disabled"  >
          <van-field
            readonly
            clickable
            :value="selectValue"
            placeholder="点击选择业务受理点"
            @click="showPickers"
          ></van-field>
          <van-popup v-model="showPicker" round position="bottom" >
            <van-picker
              show-toolbar
              title="下划查看更多服务站"
              :columns="stationOption"
              @cancel="showPicker = false"
              :visible-item-count = 9
              @confirm="onConfirm"
            />
          </van-popup>
        
        </van-row>

      <!-- <van-divider style="margin: 0;"/> -->
      <van-row>
        <van-cell class="titleStyle">2、车牌号码：</van-cell>
      </van-row>
      <van-divider style="margin: 0;"/>
      <van-row>
          <plateNumber @func="getPlateNo"  ref="plate" @plateType="getPlateType" style="margin: 5px auto;"/>
      </van-row>
      <!-- <van-divider style="margin: 0;"/> -->
      <van-row>
        <van-cell class="titleStyle" @touchstart.native.stop="showIdNoKeyboard">3、领取人身份证号码：</van-cell>
      </van-row>
      <van-divider style="margin: 0;"/>
      <!-- <van-row>
        <van-field 
          :value="ruleForm.idNo" 
          placeholder="点击输入身份证号码" 
          left-icon="edit"
          style="margin:5px auto;width: 98%;"
          readonly
          @touchstart.native.stop="showIdNoKeyboard" /> 
      </van-row> -->
      <van-row>
        <van-field 
          :value="ruleForm.idNo" 
          placeholder="点击输入身份证号码" 
          left-icon="edit"
          readonly
          style="margin:5px auto;width: 98%;"
          @touchstart.native.stop="showIdNoKeyboard" /> 
      </van-row>
      <van-divider style="margin: 0;"/>

      
      <van-row>
        <van-cell class="titleStyle" @touchstart.native.stop="showPhoneNoKeyboard">4、领取人手机号码：</van-cell>
      </van-row>
      <van-divider style="margin: 0;"/>
      <van-row>
        <van-field
        :value="ruleForm.phoneNo"
        placeholder="点击输入手机号码"
        left-icon="edit"
        style="margin:5px auto;width: 98%;"
        readonly
        @touchstart.native.stop="showPhoneNoKeyboard"
        />
      </van-row>
      <van-divider style="margin: 0 0 5px 0;"/>

    </van-cell-group>
    <div>
    <div style="margin: 8px 16px;">
      <van-button @click="goNext" round block type="info">下一步</van-button>
      <van-button  @click="goHome" round style="width: 98%; margin-top: 2%;margin-left: 0;">返回首页</van-button>
    </div>
  </div>
  </van-form>
  <!-- 身份证号键盘 -->
  <van-number-keyboard
    :show="idNoKeyboardShow"
    extra-key="X"
    title="身份证号码"
    maxlength="18"
    close-button-text="完成"
    @blur="blurIdNo"
    v-model="ruleForm.idNo"
  />
  <!-- 手机号键盘 -->
  <van-number-keyboard
    extra-key="."
    title="手机号码"
    close-button-text="完成"
    maxlength="11"
    v-model="ruleForm.phoneNo"
    :show="phoneNoKeyboardShow"
    @blur="blurPhoneNo"
  />
  <!-- 验证码键盘 -->
  <van-number-keyboard
    extra-key="."
    title="验证码"
    close-button-text="完成"
    v-model="ruleForm.verifyNo"
    :show="verifyNoKeyboardShow"
    @blur="blurVerifyNo"
  />
  <!-- 消息确认框 -->
  <!-- <van-dialog  class="applyDialog" title="确认填写信息" show-cancel-button  v-model = "dialogVisible" ref="certDialog" @confirm="handleDialogConfirm(ruleForm)" @close="closeDialog('ruleForm')">
    <van-notice-bar style="font-size: 20px;text-align: left;" color="blue" background="#ecf9ff" wrapable >
      请确认 <span style="color: red;font-size: 22px;font-weight: bold;">车牌号</span> 及 <span style="color: red;font-size: 22px;font-weight: bold;">身份证号</span> 
      等信息是否正确，如有填错，将会影响号牌领取！
    </van-notice-bar>
    <van-cell title="业务受理点："  style="font-size: 15px;">{{ setPlateValue }}</van-cell>
    <van-cell title="身份证号："  style="font-size: 15px;">{{ ruleForm.idNo }}</van-cell>
    <van-cell title="车牌类型："  style="font-size: 15px;">{{ ruleForm.plateType | formatPlateType }}</van-cell>
    <van-cell title="车牌号码："  style="font-size: 15px;">{{ ruleForm.plateNo }}</van-cell>
    <van-cell title="手机号码："  style="font-size: 15px;">{{ ruleForm.phoneNo }}</van-cell>
  </van-dialog> -->
</div>
</template>
<script>
import{ApplaySms,QueryStationDic} from '../my_js/HttpRequest'
import { Notify,Cell,Dialog} from 'vant';
import PlateNumber from '../components/plateNo.vue'
import idNoKeyBoard from '../components/keyboard.vue'
import store from '@/store/index.js'
import { WarningMsgBox } from '../my_js/common';
export default{
  components:{PlateNumber,idNoKeyBoard},
  computed:{
        isValidPhone() {
            // 使用正则表达式来验证手机号
            const regex = /^1[3-9]\d{9}$/;
            return regex.test(this.ruleForm.phoneNo);
        },
    },
  created(){
    // 获取服务站信息
    this.queryStationDic()
    // store.commit('setGetStationCode','')
    console.log('store.state.certMessage',store.state.certMessage);
    if(store.state.certMessage){
      this.ruleForm = store.state.certMessage
    }
    console.log('store.state.stationInfo',store.state.stationInfo);
    if(store.state.stationInfo){
      this.selectValue = store.state.stationInfo.text
    }
  },
  filters:{
      // 车牌类型显示转换
      formatPlateType: function (row) {
      if (row == 0) {
          return '蓝牌'
      } else if(row == 1) {
          return '绿牌'
      }else{
        return '未定义车牌类型'
      }
    },
    },
  data(){
    return{
      indexNum: 0, //必填字段，为键盘索引，每个键盘必须具有唯一值
			oldValue: '', //从父组件传递给子组件的值
      interval:null,
      idNoKeyboardShow:false,//身份证键盘
      phoneNoKeyboardShow:false,//手机号键盘
      verifyNoKeyboardShow:false,//验证码键盘
      // dialogVisible:false,//显示信息确认对话框
      active:null,
      phoneNumberArray:[],//手机号码数组
      showNumKeyboard:false,//数字键盘(手机号码)
      ruleForm: {
          idNo: '',//身份证号码
          plateType: '0',//车牌类型
          plateNo: '',//车牌号
          phoneNo:'',//手机号
          getStationCode:'',//号牌领取点
          applyStationCode:'',//业务受理点
      },
      code:'',//存储验证码
      // code:'1234',//存储验证码
      num:60,//倒计时
      numShow:true,//显示获取验证码或者数字
      keyboardVisible: false, // 控制数字键盘的显示和隐藏
      options: [{
        value: '0',
        label: '蓝牌'
      }, {
        value: '1',
        label: '绿牌'
      }],
      getPlateValue:'',//号牌领取点
      setPlateValue:null,//业务受理点
      showPicker: false,//选项是否显示
      getPlateOption:[],//下拉框选项
      stationsDicInfo:null,//服务站信息
      getPlateAddress:null,//号牌领取点信息,存储石家庄车管所一所的信息
      selectValue:'',//下拉框默认选择
      stationOption:[],//下拉框选项
      stationDic:[],//服务站字典信息
      showPicker: false,//选项是否显示
      isDisabled:false,//下拉框禁用
      // 身份证验证
      idNoRules:[{ required:true,message:'请输入身份证号', trigger:'change'},
      { pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '身份证号码格式不正确', trigger: 'blur' },
    ],
       // 车牌号验证
       plateNoRules:[{ required:true, trigger: 'change' ,message:'请输入车牌号'}],
       // 手机号验证
       phoneNoRules:[{ required:true,message:'请输入手机号码',trigger:'change'},
       { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' },
      ],
       // 验证码验证
       verifyNoRules:[{required:true,message:'请输入4位验证码',pattern: /^\d{4}$/},
        {pattern: /^\d{4}$/,message: '请输入4位数验证码',trigger: 'blur'}]
    }
  },
  methods:{
     // 返回首页
     goHome(){
        console.log('返回首页');
        const carNumber= ['冀','A']
        store.commit('setPlateNo', carNumber)
        store.commit('setCertMessage',{})
        store.commit('setStation', [])
        this.$router.push('/home')
      },
    showIdNoKeyboard() {
      this.$refs.plate.hideKeyboard()
      if(this.selectValue == '' || this.selectValue == null){
         return WarningMsgBox('请选择业务受理点')
        }else if((this.ruleForm.plateType == 0 && this.ruleForm.plateNo.length < 7)||(this.ruleForm.plateType == 1 && this.ruleForm.plateNo.length < 8)){
         return WarningMsgBox('请填写正确的车牌号')
      }
      
      this.idNoKeyboardShow = true;
      this.phoneNoKeyboardShow = false;
      this.verifyNoKeyboardShow = false;
      // this.$refs.plate.hideKeyboard()
      this.focusVerifyNo()
      
    },
    blurIdNo(){
       //重置
       this.$nextTick(() => {
      const container = document.querySelector('.certMessage');
      if (container) {
          container.style.paddingBottom = '0px';
          console.log('Container found and padding set');
          setTimeout(() => {
              console.log('Scrolling to bottom');
              container.scrollTop = container.scrollHeight;
              console.log('Scroll top set to:', container.scrollTop);
          }, 100);
      } else {
          console.error('Container not found');
      }
      });
      // 验证身份证号
      // debugger
      const reg = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
      const reg1 = new RegExp(/^[A-Z]\d{7,11}$/)
      if(!reg1.test(this.ruleForm.idNo) && !reg.test(this.ruleForm.idNo)){
        Notify({type:'warning',message:'请输入正确的身份证号'})
        // return
      }
      this.idNoKeyboardShow = false
    },
    showPhoneNoKeyboard() {
      const validIdNo = this.validateIdCard(this.ruleForm.idNo)
      if(this.selectValue == '' || this.selectValue == null){
          return WarningMsgBox('请选择业务受理点')
        }else if((this.ruleForm.plateType == 0 && this.ruleForm.plateNo.length < 7)||(this.ruleForm.plateType == 1 && this.ruleForm.plateNo.length < 8)){
          return WarningMsgBox('请填写正确的车牌号')
        }else if(!validIdNo){
          return WarningMsgBox('请填写正确的身份证号')
        }
      this.idNoKeyboardShow = false;
      this.phoneNoKeyboardShow = true;
      this.verifyNoKeyboardShow = false;
      this.$refs.plate.hideKeyboard()
      this.focusVerifyNo()
    },
    blurPhoneNo(){
      //重置
      this.$nextTick(() => {
      const container = document.querySelector('.certMessage');
      if (container) {
          container.style.paddingBottom = '0px';
          console.log('Container found and padding set');
          setTimeout(() => {
              console.log('Scrolling to bottom');
              container.scrollTop = container.scrollHeight;
              console.log('Scroll top set to:', container.scrollTop);
          }, 100);
      } else {
          console.error('Container not found');
      }
      });
      // 验证手机号
      const reg = /^1[3456789]\d{9}$/
      if(!reg.test(this.ruleForm.phoneNo)){
        Notify({type:'warning',message:'请输入正确的手机号'})
        // return
      }
      this.phoneNoKeyboardShow = false
    },
    showVerifyNoKeyboard() {
      // 首先确保隐藏其他可能显示的字段
      this.idNoKeyboardShow = false;
      this.phoneNoKeyboardShow = false;
      this.verifyNoKeyboardShow = true; // 显示验证码字段
      this.focusVerifyNo()
      // window.addEventListener('resize', function() {
      //   // 获取键盘高度
      //   var keyboardHeight = window.innerHeight - document.documentElement.clientHeight;
      //   console.log('keyboardHeight:',keyboardHeight);
      //   // 如果键盘高度大于0，表示键盘已经弹出
      //   if (keyboardHeight > 0) {
      //       // 调整页面滚动，确保验证码字段可见
      //       window.scrollTo(0, document.getElementById('captchaField').offsetTop - keyboardHeight);
      //   }
      // });
    },
    focusVerifyNo(){
      this.$nextTick(() => {
      const container = document.querySelector('.certMessage');
      if (container) {
          container.style.paddingBottom = '260px';
          console.log('Container found and padding set');
          setTimeout(() => {
              console.log('Scrolling to bottom');
              //container.scrollTop = container.scrollHeight;
              container.scrollTo(0, container.scrollHeight);
              console.log('Scroll top set to:', container.scrollTop);
          }, 100);
      } else {
          console.error('Container not found');
        }
    });
      
    },
    blurVerifyNo(){
      this.verifyNoKeyboardShow = false
      //重置
      this.$nextTick(() => {
      const container = document.querySelector('.certMessage');
      if (container) {
          container.style.paddingBottom = '0px';
          console.log('Container found and padding set');
          setTimeout(() => {
              console.log('Scrolling to bottom');
              container.scrollTop = container.scrollHeight;
              console.log('Scroll top set to:', container.scrollTop);
          }, 100);
      } else {
          console.error('Container not found');
      }
      });
    },
     // 获取车牌号
    getPlateNo(data){
        this.ruleForm.plateNo = data
    },
    // 获取车牌类型
    getPlateType(val){
      console.log('车牌类型：',val);
      this.ruleForm.plateType = val
      console.log(this.ruleForm.plateType);
    },
    // // 提交表单
    // submitForm() {
    
    //   // const validIdNo = this.validateIdCard(this.ruleForm.idNo)
    //   // console.log(validIdNo);
    //   // return
    //   console.log('表单数据：', this.ruleForm);
    //   const validIdNo = this.validateIdCard(this.ruleForm.idNo)
    //   const validPhoneNo = this.validatePhoneNo(this.ruleForm.phoneNo)
    //   if(this.getPlateValue == '' || this.getPlateValue == null){
    //       WarningMsgBox('请选择号牌领取点')
    //     }else if((this.ruleForm.plateType == 0 && this.ruleForm.plateNo.length < 7)||(this.ruleForm.plateType == 1 && this.ruleForm.plateNo.length < 8)){
    //       WarningMsgBox('请填写正确的车牌号后再提交')
    //     }else if(!validIdNo){
    //       WarningMsgBox('请填写正确的身份证号后再提交')
    //     }else if(!validPhoneNo){
    //       WarningMsgBox('请填写正确的手机号后再提交')
    //     }else{
    //       this.dialogVisible = true
    //     }
    //     // return
    //     // 表单验证成功
    //     // console.log('验证通过');
    //     // if((_this.ruleForm.plateType == 0 && _this.ruleForm.plateNo.length < 7)||(_this.ruleForm.plateType == 1 && _this.ruleForm.plateNo.length < 8)){
    //     //   Notify({type:'warning',message:'请填写正确的车牌号后再提交'})
    //     //   return
    //     // }
    //     // 显示消息确认框
    //     // _this.dialogVisible = true

    //   },
    
      //  // 关闭对话框
      // closeDialog () {
      //     this.dialogVisible = false
      //     // this.$refs.plate.resetData()//清除车牌号
      //     // this,this.ruleForm.idNo = ''//清空身份证号码
      //     // this,this.ruleForm.plateNo = ''//清空车牌号
      //     // this,this.ruleForm.phoneNo = ''//清空手机号
      //     // const carNumber= ['冀','A']
      //     // store.commit('setPlateNo', carNumber)
      // },
      // 消息确认框点击确定
      // handleDialogConfirm(){
      //   let _this = this
      //   console.log('点击了确定');
      //   this.dialogVisible = false
      //   store.commit('setCertMessage',_this.ruleForm)
      //   this.$router.replace('/station')
      // },
      // 获取验证码
      getMScode(){
        this.phoneNoKeyboardShow= false
        let _this = this
          if(!_this.isValidPhone){
            Notify({ type: 'warning', message: '请输入正确的手机号！' });
            console.log('phoneVal:',_this.ruleForm.phoneNo);
            return
        }
        // 发送验证码
        console.log('发送验证码到手机号：',_this.ruleForm.phoneNo);
        // debugger
        console.log(_this.ruleForm.plateNo);
        if(_this.ruleForm.idNo == '' ||_this.ruleForm.plateType=='' ||_this.ruleForm.plateNo.length<=2){
            Notify({ type: 'warning', message: '请先填写身份证、车牌类型、车牌号信息' });
        }else{
            console.log('表单数据：',_this.ruleForm);

            ApplaySms(_this.ruleForm,function(res){
            console.log('sendMessage',res);
            _this.code = res.msg
            console.log(_this.code);
        })
          // 倒计时
          _this.numShow = false
            let count = setInterval(()=>{
                _this.num--
                if(_this.num==0){
                    clearInterval(count)
                    _this.numShow=true
                    _this.num = 60
                }
            },1000)
        }
      },
      // 验证身份证号
      validateIdCard(idCard) {
        // debugger
        console.log(idCard)
        const CheckCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        const Weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          // 校验长度
          if (idCard.length !== 18) {
              return false;
          }

          // 校验地区码
          const areaCode = idCard.substring(0, 6);
          if (!/^\d{6}$/.test(areaCode)) {
              return false;
          }

          // 校验出生日期
          const birthDate = idCard.substring(6, 14);
          const date = new Date(`${birthDate.substring(0, 4)}-${birthDate.substring(4, 6)}-${birthDate.substring(6, 8)}`);
          if (date.getFullYear() !== parseInt(birthDate.substring(0, 4), 10) ||
              date.getMonth() + 1 !== parseInt(birthDate.substring(4, 6), 10) ||
              date.getDate() !== parseInt(birthDate.substring(6, 8), 10)) {
              return false;
          }

          // 校验顺序码
          const orderCode = idCard.substring(14, 17);
          if (!/^\d{3}$/.test(orderCode)) {
              return false;
          }

          // 校验校验码
          const checkCode = idCard[17];
          let sum = 0;
          for (let i = 0; i < 17; i++) {
              const digit = parseInt(idCard[i], 10);
              sum += digit * Weights[i];
          }
          const mod = sum % 11;
          const expectedCheckCode = CheckCodes[mod];
          if (checkCode.toUpperCase() !== expectedCheckCode) {
              return false;
          }

          // 校验通过
          return true;

        },
      // 验证手机号
      validatePhoneNo(value){
        const regex = /^1[3-9]\d{9}$/;
        return regex.test(value); 
      },
       // 选择的业务受理点
       onConfirm(val) {
        console.log('用户选择的业务受理点',val);
        this.selectValue = val.text;
        this.showPicker = false;
        this.setPlateValue = val.text
        this.ruleForm.applyStationCode = val.value
        store.commit('setStation', val)
      },
      showPickers(){
        if(this.isDisabled){

        }else{
          this.showPicker=true
        }
        
      },
       // 获取服务站信息
       queryStationDic(){
        QueryStationDic().then(res => {
          console.log(res);
          this.stationDic = res.data
          this.stationDic.forEach(element => {
            this.stationOption.push({text:element.name,value:element.code,getStation:element.getStation})
          });
          console.log('服务站信息:',this.stationOption);
          console.log('setUrlStationCode', store.state.urlStationCode)
          const setStation = store.state.urlStationCode
          const filterStation = this.stationOption.filter(element => element.value == setStation)
          console.log('filterStation',filterStation);
          console.log(this.isDisabled);

          if(filterStation.length != 0){
            this.onConfirm(filterStation[0])
            this.isDisabled = true
          }else {
            this.isDisabled = false
            console.log(this.stationOption);
          }

          if(this.ruleForm.applyStationCode){
            // 用户上一次选择的业务受理点
            const applyOption = this.selectValue = this.stationOption.filter(item => item.value == this.ruleForm.applyStationCode)
            console.log('applyOption',applyOption);
            
            this.onConfirm(applyOption[0])
          }
        })
      },
      // 选项发生变化
      selectChange(val){
        console.log('val:',val);
        // const data = {}
        
        this.stationDic.forEach(item => {
          if (val == item.code){
            console.log('item',item);
            store.commit('setStation', item)
          }
        })
      },
      // 下一步
      goNext(){
      console.log('表单数据：', this.ruleForm);
      const validIdNo = this.validateIdCard(this.ruleForm.idNo)
      const validPhoneNo = this.validatePhoneNo(this.ruleForm.phoneNo)
      if(this.selectValue == '' || this.selectValue == null){
          WarningMsgBox('请选择业务受理点')
        }else if((this.ruleForm.plateType == 0 && this.ruleForm.plateNo.length < 7)||(this.ruleForm.plateType == 1 && this.ruleForm.plateNo.length < 8)){
          WarningMsgBox('请填写正确的车牌号')
        }else if(!validIdNo){
          WarningMsgBox('请填写正确的身份证号')
        }else if(!validPhoneNo){
          WarningMsgBox('请填写正确的手机号')
        }else{
          // this.dialogVisible = true
          console.log('表单数据：', this.ruleForm);
          store.commit('setCertMessage',this.ruleForm)
          this.$router.replace('/station')
          this.$refs.plate.resetData(this.ruleForm.plateNo)//清除或保存车牌号
        }
      },
  }
}
</script>
<style lang="scss">
.certMessage{
  width: 100%;
  height: 100%;
  overflow-y: auto; /* 尝试使用 auto */
  background-color: #F7F8FA;
  .van-number-keyboard{
    background-color: #F2F3F5;
    padding: 0;
  }
  .van-key{
    width: 100%;
  }
  .van-cell__value{
    text-align: left;
  }
  .van-button--small{
    padding: 0 10px;
  }
  .titleStyle{
    .van-cell__value--alone{
      color: #1989fa;
      font-weight: bold;
      // font-size: 16px;
    }
    
  }
  .stationPicker{
      .van-picker__title{
      color: #fa8f04;
      font-weight: bold;
    }
    }
}
.applyDialog{
  width: 95%;
  .van-dialog--round-button .van-dialog__footer{
    padding: 8px 3px 10px;
    // color: orange;
  }
  .van-dialog__header{
    color: #1989fa;
    font-weight: bold;
    padding: 10px;
  }
  .van-button--default{
    background-color: rgba(248, 246, 246, 0.986);
    margin: 5px;
  }
  .van-dialog__confirm {
    background-color: #1989fa;
    color: white;
  }
}

  .select{
      // border: red 1px solid;
      .van-dropdown-menu{
        margin: 2%;
        border: gainsboro 1px solid;
      }
    .van-popup--bottom.van-popup--round{
      height: 50%;
    }
    .van-picker__title{
      color: #fa8f04;
      font-weight: bold;
    }
    }
</style>